


export default defineNuxtPlugin(nuxtApp => {
    const config = useRuntimeConfig()
    const apiUrl = config.public.NUXT_API_BACK_URL

    nuxtApp.vueApp.provide('apiUrl', apiUrl)
    nuxtApp.provide('apiUrl', apiUrl)

})